import React from "react";
import "./StatusModal.css";

const StatusModal = ({ isOpen, onClose, onConfirm, time, message = "" }) => {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay" onClick={onClose}>

      <div className="delete-modal-contents" onClick={(e) => e.stopPropagation()}>
        <div className="some-data">
          <h2 className="delete-modal-title">Last Demand At</h2>
          <label className="close-btns-tata" onClick={onClose}>X</label>

        </div>

        <h3 className="delete-modal-titless">{time}</h3>
        <p className="delete-modal-messages">
          <span className="label-loca">Location:</span> {message || 'No Records Found'}
        </p>

      </div>
    </div>
  );
};

export default StatusModal;
